/**
 * 浏览器直传 OSS PostObject（不经指挥服务器文件体）
 * 使用 XHR 以便回报上传百分比
 */
export function postObjectToOss(upload, file, objectKey, onProgress) {
  if (!upload?.host || upload.mode === 'disabled') {
    return Promise.reject(new Error(upload?.message || 'OSS 未配置，无法直传'));
  }
  return new Promise((resolve, reject) => {
    const form = new FormData();
    form.append('key', objectKey);
    form.append('policy', upload.policy);
    form.append('OSSAccessKeyId', upload.accessKeyId);
    form.append('Signature', upload.signature || upload.Signature);
    form.append('success_action_status', String(upload.success_action_status || '200'));
    form.append('file', file);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', upload.host);
    xhr.upload.onprogress = (evt) => {
      if (!evt.lengthComputable || typeof onProgress !== 'function') return;
      const percent = Math.min(99, Math.round((evt.loaded / evt.total) * 100));
      onProgress({ percent, loaded: evt.loaded, total: evt.total });
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        if (typeof onProgress === 'function') onProgress({ percent: 100, loaded: file.size, total: file.size });
        resolve();
        return;
      }
      const text = String(xhr.responseText || '').slice(0, 160);
      reject(new Error(`OSS 上传失败 ${xhr.status}${text ? `: ${text}` : ''}`));
    };
    xhr.onerror = () => reject(new Error('OSS 网络错误（可能被 CORS 拦截，请检查 Bucket 跨域）'));
    xhr.onabort = () => reject(new Error('上传已取消'));
    xhr.send(form);
  });
}
